import { styled } from '@linaria/react';

import { fonts, primitives, radius, semantic, size, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
`;

export const MethodHeading = styled.h4`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const MethodRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
`;

export const MethodOption = styled.label`
  display: flex;
  align-items: center;
  gap: ${space['space-500']};
  padding: ${space['space-500']};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  border-radius: ${radius('card', 'radius-lg')};
  background: ${semantic.bg.canvas};
  box-sizing: border-box;
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};

  &[data-selected='true'] {
    border-width: ${size.stroke['stroke-thick']};
    border-color: ${semantic.border.selected};
  }

  &[data-disabled='true'] {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const MethodIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${semantic.text.primary};
  flex-shrink: 0;
`;

export const MethodLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${space['space-200']};
  flex: 1;
`;

export const MethodPrice = styled.span`
  margin-left: auto;
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
`;

export const MessageBox = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
`;

export const CostRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space['space-300']} ${space['space-400']};
  background: ${semantic.bg.surfaceSubtle};
  border-radius: ${radius('card', 'radius-sm')};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.primary};
`;
